/**
 * MRP Draft POs (/mrp/draft-pos) — LEGACY route.
 *
 * Feb 2026 Phase 2: the standalone MRP-draft-POs view has been merged
 * into the unified Purchase Orders page at /procurement/purchase-orders.
 * MRP-generated POs are now surfaced there tagged `source.kind === "MRP_DRAFT"`.
 * This wrapper redirects any deep-link so no bookmark breaks.
 */
import { Navigate } from 'react-router-dom';

export default function MRPDraftPOs() {
  return <Navigate to="/procurement/purchase-orders" replace />;
}
